import { connect } from 'react-redux'
import {
    cancelOrder,
    discard,
    fetchOrders,
    isParkingOpen
} from 'shared/store/ecommerce/order'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { OrdersListComponent } from './OrdersListComponent'
import type { CacOrder, DeviceCheck, OrbOrderShortDTO } from 'shared/types'
import { getDisplayableOrders } from 'shared/utils/ecommerce/utils'
import { push } from 'connected-react-router'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import type { FetchOrdersParams } from 'shared/store/ecommerce/order'
import { isMobile, isTablet } from 'react-device-detect'

const mapStateToProps = (state: RootState) => {
    const { orders, error } = state.orbState
    const { authenticated } = state.userState
    const { cacOrders, products, promotions } = state.ecommerceOrderState

    const allOrders = {
        ...cacOrders,
        ...orders
    }
    const displayableOrders = getDisplayableOrders(
        allOrders,
        !isMobile && !isTablet
    )

    let pastOrders = []
    let currentOrders = []
    displayableOrders.forEach((order: CacOrder | OrbOrderShortDTO) => {
        if (order.discarded) {
            pastOrders.push(order)
        } else {
            currentOrders.push(order)
        }
    })
    const hasCart = products?.length > 0 || promotions?.length > 0

    return {
        error,
        authenticated,
        pastOrders,
        currentOrders,
        hasCart
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    discard: (order: CacOrder) => d(discard(order)),
    cancelOrder: (id: string, token: string, deviceCheckPayload: DeviceCheck) =>
        d(cancelOrder(id, token, deviceCheckPayload)),
    fetchOrders: (fetchOrdersParams?: FetchOrdersParams) =>
        d(fetchOrders(fetchOrdersParams)),
    isParkingOpen: () => d(isParkingOpen()),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    navigate: (to: string) => d(push(to))
})

const OrdersList = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrdersListComponent)

export { OrdersList }
